import { registerIconAlias } from '@uifabric/styling/lib/index';
registerIconAlias('trash', 'delete');
//# sourceMappingURL=icon-aliases.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/icons/lib-es2015/icon-aliases.js
// module id = 568
// module chunks = 0